import * as React from "react";
import { api } from "src/services/api";
import { classNames, __, __BETA } from "src/services/theme";
import OrdineCheckout from "./OrdineCheckout";
import { Formatters, Loading } from "src/components/ui";
import { alert } from "src/services/notify";

interface Props {
  pacchetti: {
    id: string,
    crediti: number,
    prezzo: number
  }[];
  costo_credito: number;
  necessari?: number;
}

interface State {
  phase: string;
  current: any;
  indirizzo?: any;
}

export default class RicaricaCrediti extends React.Component<Props, State> {
  
  constructor( props ) {
    super(props);
    if (!props.necessari) {
      this.state = {
        phase: "INDEX",
        current: props.pacchetti[0] // props.pacchetti.filter( p => props.necessari <= p.crediti )[0]
      }
    } else {
      this.state = {
        phase: "ORDINE",
        current: {
          crediti: props.necessari,
          prezzo: props.costo_credito * props.necessari
        }
      }
    }
  }
  
  focus(i) {
    this.setState({
      current: i
    });
  }
  
  continue() {
    if (__BETA) {
      alert( { text: __('RicaricaCrediti.coming_soon'), type: 'success' } );
    } else {
      this.setState({
        phase: "ORDINE"
      })
    }
  }
  
  submit( { indirizzo, codice } ) {
    const { current } = this.state;
    api({
      method: "POST",
      url: "ordine/prePay",
      data: {
        prodotti: [{
          ...current,
          model: 'App\\Ecommerce\\Crediti',
          descrizione: 'Crediti'
        }],
        totale: current.prezzo,
        indirizzo,
        codice
      }
    });
  }
  
  
  render() {
    const { pacchetti, necessari = 0 } = this.props;
    const { phase, current, indirizzo } = this.state;
    return (
      <div className="ecommerce_RicaricaCrediti">
        <header>
          Ricarica crediti Schoolvisor
        </header>
        {phase === "INDEX" &&
        <>
        <div className="list-bg">
        <div className="container">
          <section className="list">
            <article>
              <header>
                <h3>Crediti Schoolvisor</h3>
                <p>Ottieni tutti i servizi del mondo Schoolvisor.</p>
              </header>
              {pacchetti.map((p, i) => {
                const enabled = necessari <= p.crediti;
                return (
                  <article
                    key={i}
                    className={classNames(!enabled ? 'disabled' : null, current.id === p.id ? 'active' : null)}
                    onClick={() => enabled ? this.focus(p) : null}
                  >
                    <span>
                      <span className={current.id === p.id ? "icon-radio-on" : "icon-radio-off"} />
                    </span>
                    <span>
                      <strong>{p.crediti}</strong>
                      <span>Crediti</span>
                    </span>
                    <span>
                      <strong>{Formatters.Price({val: p.prezzo})}</strong>
                      <small>
                      {Formatters.Price({val: p.prezzo / p.crediti})}/credito
                      </small>
                    </span>
                  </article>
                )
              })}
              <footer>
                <button className="cancel" onClick={() => this.continue()}><span>
                Acquista {current.crediti} crediti
                </span></button>
              </footer>
            </article>
            <div>
              <h3>Claim per acquisto crediti</h3>
              <article>
                <div>
                  <span className="icon-marker" />
                </div>
                <div>
                  <strong>Vantaggio 1</strong>
                  delle posizioni
                </div>
              </article>
              <article>
                <div>
                  <span className="icon-list" />
                </div>
                <div>
                  <strong>Vantaggio 2</strong>
                  nelle ricerche
                </div>
              </article>
              <article>
                <div>
                  <span className="icon-positive_dynamic_filled" />
                </div>
                <div>
                  <strong>Vantaggio 3</strong>
                  della tua scuola
                </div>
              </article>
            </div>
          </section>
        </div>
        </div>
        <div className="faq container">
          <h2><span>Domande frequenti</span></h2>
          <div className="items">
            <article>
              <h4>{__('AcquistiCrediti.faq1_title')}</h4>
              <p>{__('AcquistiCrediti.faq1_text', 130)}</p>
            </article>
            <article>
              <h4>{__('AcquistiCrediti.faq2_title')}</h4>
              <p>{__('AcquistiCrediti.faq2_text', 130)}</p>
            </article>
            <article>
              <h4>{__('AcquistiCrediti.faq3_title')}</h4>
              <p>{__('AcquistiCrediti.faq3_text', 130)}</p>
            </article>
            <article>
              <h4>{__('AcquistiCrediti.faq4_title')}</h4>
              <p>{__('AcquistiCrediti.faq4_text', 130)}</p>
            </article>
            <article>
              <h4>{__('AcquistiCrediti.faq5_title')}</h4>
              <p>{__('AcquistiCrediti.faq5_text', 130)}</p>
            </article>
            <article>
              <h4>{__('AcquistiCrediti.faq6_title')}</h4>
              <p>{__('AcquistiCrediti.faq6_text', 130)}</p>
            </article>
            <article>
              <h4>{__('AcquistiCrediti.faq7_title')}</h4>
              <p>{__('AcquistiCrediti.faq7_text', 130)}</p>
            </article>
          </div>
        </div>
        </>
        }
        {phase === "ORDINE" &&
        <section>
          <div className="container">
            <OrdineCheckout
              items={[{nome: `Ricarica ${current.crediti} crediti`, prezzo: current.prezzo}]}
              onSubmit={(args) => this.submit(args)}
              onBack={() => this.setState({phase: "INDEX"})}
            />
          </div>
        </section>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/RicaricaCrediti.tsx